import React from 'react';
import { GUARANTEE_DAYS } from '../data/offer';

/**
 * Section 3 — stands in for the first testimonial run until a pilot cohort
 * exists. No quote, name or photo appears anywhere on this page until the
 * quotes are real.
 */
const substance = ['Every template is undated and every record field is blank. Nothing is pre-filled, because nothing about your homeschool is assumed.', 'Every kid-facing card carries tasks and nothing else — no ages, no levels, no labels of any kind printed anywhere.', 'Both standard paper sizes ship from day one, built from the same source, so nothing is cropped on your printer.'];
export function HonestyBlock() {
  return <section aria-labelledby="honesty-heading" className="w-full bg-white" data-id="element-153" data-mp="x6cxrgmpezzt">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-154" data-mp="115vkmhy35l5a">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-10 lg:gap-16" data-id="element-155" data-mp="2rj2s1zgzib7q">
          <div data-id="element-156" data-mp="2vk4usqa415eg">
            <h2 id="honesty-heading" className="font-serif font-bold text-ink text-2xl sm:text-3xl lg:text-[40px] lg:leading-[1.1]" data-id="element-157" data-mp="2vileizogeuco">
              No testimonials yet. Here&apos;s the honest version instead.
            </h2>
            <p className="mt-5 text-ink-soft leading-relaxed" data-id="element-158" data-mp="3bpbg5aslzduc">
              This is new. There is no wall of five-star quotes on this page,
              because there isn&apos;t a wall of five-star quotes yet — and
              borrowing one would be the fastest way to lose you. What there is:
              a finished system, printed and tested page by page, and a{' '}
              {GUARANTEE_DAYS}-day guarantee that exists precisely because you
              have no reason to take our word for anything.
            </p>
          </div>

          <ul className="border-t border-cream-dark" data-id="element-159" data-mp="2nz7eva2w7q6i">
            {substance.map((line, index) => <li key={line} className="flex gap-5 py-6 border-b border-cream-dark" data-id="element-160" data-mp="87b3hic3ykae" data-mpi={index}>
                <span className="font-serif font-bold text-sage text-lg leading-snug shrink-0" aria-hidden="true" data-id="element-161" data-mp="3c442mpvg1ra">
                  0{index + 1}
                </span>
                <p className="text-[15px] sm:text-base leading-relaxed text-ink" data-id="element-162" data-mp="kbf6eqbr26nf">
                  {line}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}